import { render, staticRenderFns } from "./OrderTypeSummary.vue?vue&type=template&id=7198cb27&"
import script from "./OrderTypeSummary.vue?vue&type=script&lang=ts&"
export * from "./OrderTypeSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports